var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v("堆叠面积图")]),_c('div',{staticClass:"inner"},[_c('ve-line',_vm._b({attrs:{"data":_vm.chartData,"settings":_vm.chartSettings}},'ve-line',_vm.pubSetting,false))],1),_c('template',{slot:"footer"},[_c('d2-link-btn',{attrs:{"title":"更多示例和文档","link":"https://v-charts.js.org"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }